// system
function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
$('.banner h1 i').hover(function(){
    console.log(1)
    $(this).find('.jump').toggle();
});
$('.banner h1 i').on('clic','a',function(){
    if(!device_confirm()){
        var _h = $(this).attr('href');
        window.open(_h,'_self');
    }
});


$(function () {
    for(var i=0;i<3;i++){
      var type=$('.payment a').eq(i).css('display');
      for(var j=0;j<$('.product_buy .pay_payment').length;j++){
        $('.pay_payment').eq(j).children('span').eq(i).css('display',type)
      }
    }
    for(var i=0;i<$('.item .payment a').length;i++){
        var type1=$('.item .payment a').eq(i).css('display');
        $('.item .pay_payment span').eq(i).css('display',type1)
    }
    for(var i=0;i<$('.order_bundle .bundle_buy a').length;i++){
        var type1=$('.order_bundle .bundle_buy a').eq(i).css('display');
        $('.order_bundle .bundle_buy span').eq(i).css('display',type1)
    }
  });
  function show_time(day){
    var time_start = new Date().getTime(); //设定当前时间
    // 计算时间差
    var time_distance = day - time_start;//604800000
    // 天
    var int_day = Math.floor(time_distance/86400000)
    time_distance -= int_day * 86400000;
    // 时
    var int_hour = Math.floor(time_distance/3600000)
    time_distance -= int_hour * 3600000;
    // 分
    var int_minute = Math.floor(time_distance/60000)
    time_distance -= int_minute * 60000;
    // 秒
    var int_second = Math.floor(time_distance/1000)
    // 时分秒为单数时、前面加零
    if(int_day < 10){
        int_day = "0" + int_day;
    }
    if(int_hour < 10){
        int_hour = "0" + int_hour;
    }
    if(int_minute < 10){
        int_minute = "0" + int_minute;
    }
    if(int_second < 10){
        int_second = "0" + int_second;
    }
    // 显示时间
    $(".countdown_day").html(int_day);
    $(".countdown_hours").html(int_hour);
    $(".countdown_minute").html(int_minute);
    $(".countdown_second").html(int_second);
    return {int_hour:int_hour,day:day};
};
if(!window.localStorage.getItem('day')){
    window.localStorage.setItem('day',new Date().getTime()+86400000);
    clearInterval(time);
    var time=setInterval(function(){
        show_time(window.localStorage.getItem('day'));
    },1);
}else{
    clearInterval(time);
    var time=setInterval(function(){
        show_time(window.localStorage.getItem('day'));
    },1);
};
setTimeout(function(){
    for(var i=0;i<$('.time_limit>div i').length;i++){
        if($('.time_limit>div i').eq(i).html().indexOf('-')!=-1||Number($('.time_limit>div i').eq(i).html())>1){
            window.localStorage.setItem('day',new Date().getTime()+86400000);
        }else{
            break;
        }
    }
},20);
//ultra mobile bundle 切换
$(function(){
   $('.order_bundle select').change(function(){
      var i = $(this).val();
      $('.order_bundle .bundle_box .price_list').eq(i).addClass('active').siblings('.price_list').removeClass('active');
      $('.payment.bundle_buy div.pay').eq(i).addClass('active').siblings().removeClass('active');
      $('.bundle_img .img_list').eq(i).addClass('active').siblings('.img_list').removeClass('active');
      $('.bundle_img .type_list').eq(i).addClass('active').siblings('.type_list').removeClass('active');
   })
})